import styled from 'styled-components';

import { Flex } from 'reflexbox';

const FlexWithGap = styled(Flex)`
    gap: ${(props) => props.gap ?? 0};
`;
export default FlexWithGap;